var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "url(#paint0_linear_36576_1998)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 18,
    height: 6,
    fill: "url(#paint1_linear_36576_1998)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    fill: "url(#paint2_linear_36576_1998)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 18,
    height: 6,
    fill: "url(#paint3_linear_36576_1998)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 6,
    height: 6,
    fill: "url(#paint4_linear_36576_1998)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 18,
    height: 6,
    fill: "url(#paint5_linear_36576_1998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36576_1998",
    x1: 3,
    y1: 0,
    x2: 3,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36576_1998",
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36576_1998",
    x1: 3,
    y1: 8,
    x2: 3,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36576_1998",
    x1: 17,
    y1: 8,
    x2: 17,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36576_1998",
    x1: 3,
    y1: 16,
    x2: 3,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36576_1998",
    x1: 17,
    y1: 16,
    x2: 17,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoActive);
export default __webpack_public_path__ + "static/media/info-active.8707991a9e1098593668d61039c2f4d4.svg";
export { ForwardRef as ReactComponent };